import { TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  LOCALE_ID, Inject
} from '@angular/core';
import { FormBuilder} from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';

import { Observable, tap, map, catchError, throwError } from 'rxjs';
import { ScheduleLegend } from 'src/models/scheduleLegend';
import { User } from 'src/models/user';
import { APIBrandsService } from 'src/services/api-services/api-brands-service';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { brands } from 'src/services/api-services/api-interfaces/brands.interface';
import { city } from 'src/services/api-services/api-interfaces/city.interface';
import { CustomSchedule } from 'src/services/api-services/api-interfaces/custom-schedule.interface';
import { ServiceAdvisor } from 'src/services/api-services/api-interfaces/ServiceAdvisor.interface';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { HelperService } from 'src/services/helperService';
import { CancelAppointmentDialog } from './dialogs/cancel-appointment/cancel-appointment.dialog';
import { RescheduleAppointmentDialog } from './dialogs/reschedule-appointment/reschedule-appointment.dialog';
import moment from 'moment';
import { Brand } from '../../models/brand';
import { Workshop } from '../../models/workshop';
import { SearchPlateDialog } from './dialogs/search-plate/search-plate.dialog';
import { ScheduleStateService } from 'src/services/scheduleStateService.service';
import { TranslateService } from '@ngx-translate/core';

import { APIWorkshopService } from 'src/services/api-services/api-workshop.service';
import { APIServiceAdvisorBlockedSchedule } from '../../services/api-services/api-advisor-blocked-schedule-service';
import { CapitalizePipe } from '../pipes/capitalize.pipe';
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import allLocales from '@fullcalendar/core/locales-all';
import 'bootstrap';
import { PopoverReschedulingComponent } from './dialogs/popover-rescheduling/popover-rescheduling.component';
import { Router } from '@angular/router';
@Component({
    selector: 'app-scheduling',
    templateUrl: './scheduling.component.html',
    styleUrls: ['./scheduling.component.sass'],
    encapsulation: ViewEncapsulation.None,
    providers: [TitleCasePipe, CapitalizePipe],
    standalone: false
})

export class SchedulingComponent implements OnInit {
  // @ViewChild(TooltipDirective, { static: false }) public tooltipDir:
  //   | TooltipDirective
  //   | undefined;

  //Observable variable
  brands$: Observable<brands[]> = new Observable<brands[]>();
  cities$: Observable<city[]> = new Observable<city[]>();
  typesOfservice$: Observable<typeOfService[]> = new Observable<typeOfService[]>();
  workshops$: Observable<Workshop[]> = new Observable<Workshop[]>();
  advisors$: Observable<ServiceAdvisor[]> = new Observable<ServiceAdvisor[]>();
  schedulerData$: Observable<any> = new Observable<any[]>();


  displayDefaultLegends: boolean = true; // is Scheduler Disabled style
  areFiltersLoading: boolean = true; //are filters loading variable
  isSearchedByPlate: boolean = false; //loading search by plate
  isSearchingSchedules: boolean = false; //loading search schedules
  isAdvisorQueryCalled: boolean = false; // check if the advisor query is used being used
  isDisabled = false; //enable or disable the button
  selectedViewIndex: number = 1; //view index day week month
  plateNumberSearch: string = ''; // plate number search text input from plate number search
  searchedFilterElement = ''; // text that defines what is being looked for example: advisor,brands,cities, etc..

  //User variables
  userProfile: User;
  userCountryId: number = 0;
  userId: number | undefined;
  roleId: number = this.helperService.user.role.roleId
  slotDuration= 15

  //Set to each dropdown list each of its elements
  typesOfServices: typeOfService[] = [];
  advisorsResp: ServiceAdvisor[] = [];
  workshopResp: Workshop[] = [];
  userBrand: Brand = {} as Brand;

  // Option selected by user
  selectedBrand?:brands;
  selectedCity?:city;
  selectedTypeOfService?:typeOfService;
  selectedWorkshop?:Workshop
  selectedAdvisor?: ServiceAdvisor;

  // Blocked services
  BloquesFiltered:any []=[]
  DisableDates:any []=[]
  notAvailableSlots: Date[] = []
  servicesBlocksAdvisor: any[] = [];
  workshopBlockedServices:any[] = [];

  // Date and time
  startTime: string = '04:00';
  endTime: string = '20:00';
  currentDate:Date = new Date();
  minSchedulerDates= new Date(new Date().setMonth(new Date().getMonth() - 3)) // max moment on the past where calendar can arrives
  maxSchedulerDates = new Date(new Date().setMonth(new Date().getMonth() + 3))// max moment on the future where calendar can arrives

  attentionSchedule: any[] = [];
  schedulerEvents: any[] = [];
  businessHoursMap:any[] =[];
  customScheduleResp: CustomSchedule[] = [];
  dateInitial: any = new Date();

  //design of different events or calendar availability
  legends: ScheduleLegend[] = [
    {
      label: "Available",
      legendConfig: {
        order: 1,
        forecolor: '#FFFFFF',
        backcolor: '#F2F2F2',
        class: 'legend-available',
      },
    },
    {
      label: "NotAvailable",
      legendConfig: {
        order: 2,
        forecolor: '#f5f5f5',
        backcolor: '#D9D9D9',
        class: 'legend-not-available',
      },
    },
    {
      label: 'Event',
      legendConfig: {
        order: 3,
        forecolor: ' #71D4EF',
        backcolor: '#16BAE7',
        class: 'legend-1',
      },
    },
  ];


  // Interactive calendar with day, week and month views
  calendarOptions: CalendarOptions = {
    // Initial view in week format
    initialView: 'timeGridWeek',
    // Type of view
    plugins: [timeGridPlugin,dayGridPlugin, interactionPlugin],
    //organizes calendar toolbar
    headerToolbar: {
      left: 'today prev,next',
      center:'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    initialDate: this.dateInitial,
    // Function to be called when clicking on a date
    dateClick: (arg) => this.openDialog(arg),
    allDaySlot:false,
    // Type of languaje
    locales:  allLocales,
    locale: this.helperService.user.language.split('-')[0],
    // Function called when clicking on an event
    eventClick: (info) => this.onAppointmentClick(info),
    businessHours: this.businessHoursMap,
    contentHeight:'auto',
    slotLabelFormat:{
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      meridiem: true
    },
    eventTimeFormat: {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      meridiem: true
    },
    slotMaxTime:"20:00:00",
    slotMinTime:"05:00:00",
    slotDuration: `00:${this.slotDuration}:00 `,
    slotLabelInterval: this.slotDuration,
    validRange: {
      start: new Date(new Date().getFullYear(), 0, 1),
      end: new Date(new Date().getFullYear()+1, 1, 31)
    }, //Valid end date (January 31 of next year)


  };



  constructor(
    public APIWorkshopService:APIWorkshopService,
    public brandsService: APIBrandsService,
    public helperService: HelperService,
    public ServiceAdvisorApi: APIServiceAdvisorService,
    private fb: FormBuilder,
    public dialog: MatDialog,

    public titleCasePipe: TitleCasePipe,
    public customScheduleService: APICustomScheduleService,
    public schedulerService: APISchedulerService,
    public scheduleStateService: ScheduleStateService,
    public APIServiceAdvisorBlockedSchedule: APIServiceAdvisorBlockedSchedule,
    private translate: TranslateService,
    private capitalizePipe: CapitalizePipe,
    private router: Router,
    @Inject(LOCALE_ID) public localeId: string
  ) {
      this.userProfile = this.helperService.user;
      this.onScheduleStateChange()
    }

  ngOnInit(): void {
    if (this.helperService.user.role.roleId === 7) {
      this.router.navigate(['administration/users']);
    }
    this.evaluateUser();
    this.userId = this.helperService.userId;
    this.userBrand = this.helperService.brand;
    this.userCountryId = this.helperService.user.countryId;
    const module =this.helperService.modules.filter((module)=>module.label==='Scheduling')[0]
    this.helperService.icon = "calendar_month"
    this.helperService.TitlePage = module.label
  }

  brandId: number = 0; // id from brand selected on the dropdown
  advisor=0; // id from advisor selected on the dropdown
  cityId: number = 0; // id from city selected on the dropdown
  typeOfServiceId: number = 0;  // id from type of Service selected on the dropdown
  workshop: number = 0;  // id from workshop selected on the dropdown
  userProfileId: number = 0;
  parsedHovered;
  parsedHoveredTypeOfService: string = '';
  parsedHoveredHourstart: string = '';
  parsedHoveredHourEnd: string = '';
  parsedHoveredClientFirstName: string = '';
  parsedHoveredClientLastName: string = '';
  parsedHoveredPlate: string = '';
  parsedHoveredBrand: string = '';
  brandChange: number = 0;
  dayViewTitle = 'Day'
  weekViewTitle = 'Week'
  monthViewTitle = 'Month'
  todayViewTitle = 'Today'

  onAppointmentClick(appointment:any) {
  
     if(!appointment.jsEvent.target.classList.contains('fc-bg-event')){ //Prevents certain click events from executing the rest of the code.
      let originalTime = new Date(appointment.date);
      let newTime = new Date(originalTime.getTime() + this.slotDuration * 60000)//30 minutes are added to the current time.

      let dataAppointmet:any = {
        ...appointment.event._def.extendedProps, //All properties are copied to 'dataAppointmet'.
        hour:appointment.el.innerText.split('\n')[0], //Divides the text by lines and takes the first line.
        id:appointment.event._def. publicId,
        attentionSchedule: this.attentionSchedule,
        schedules:this.schedulerEvents,
        blocks :this.servicesBlocksAdvisor,
        start: appointment.date,
        end: newTime,
      }
      // const DateEventStart = new Date(dataAppointmet.EventStart)
      
      // if( DateEventStart.setHours(0, 0, 0, 0)>= new Date().setHours(0, 0, 0, 0)){
      
        const dialogRef = this.dialog.open(PopoverReschedulingComponent, {
          width: '600px',
          panelClass: 'icon-outside',
          data: dataAppointmet,
        });
        dialogRef.afterClosed().subscribe(result => {
  
        });
      // }
     
      
     }

  }

  //This function takes a date string and hours string as parameters and returns a Date object.
  addObjectDateTimePropery(date: string, hours: string):Date {
    // It first splits the date string into an array of strings
    const dateSplit = date.split(' ')[0];
    //then combines the date string with the hours string to create a new date string.
    const newDate = `${dateSplit} ${hours}`;
    //Finally, it uses moment.js to convert the new date string into a Date object and returns it.
    const Date = moment(newDate, 'M/DD/YYYY HH:mm:ss').toDate();
    return Date;
  }

  //CONTAC CENTER (role id 3) Y RETAIL GROUP (role id 4) because its the same filter
  onCCRGFilterSearchClick(): void {
    this.plateNumberSearch=''
    this.notAvailableSlots=[]
    this.prevMonth()
    this.isSearchedByPlate = false;
    this.displayDate=new Date()
    this.attentionSchedule = [];
    this.schedulerEvents = [];
    this.BloquesFiltered =[]
    this.DisableDates =[]
    this.isSearchingSchedules = true;

    if (this.advisor > 0) {
      this.getServiceAdvisorData(this.advisor);
      return;
    }
    // No prefered advisor 'Sin preferencia CC'
    this.isAdvisorQueryCalled = false;
    this.schedulerData$ = new Observable<any[]>();
    this.schedulerData$ = this.customScheduleService
      .getFilteredData(
        this.roleId,
        this.userCountryId,
        this.brandId,
        this.cityId,
        this.typeOfServiceId,
        this.workshop,
        this.advisor
      )
      .pipe(
        tap({

          next: (value) => {

            return [value];
          },
        }),
        map((value) => {

          // Map Bussines hour for brand
          this.attentionSchedule = value.attentionScheduleByBrandDTO;
          this.businessHoursMap.forEach((hours,index) => {
            hours.daysOfWeek=[index]
            hours.startTime= "00:00"
            hours.endTime= "00:00"
          })
          value.attentionScheduleByBrandDTO.forEach(schedule => {
            const dayNumber = parseInt(schedule.dayNumber);
            const startTime = schedule.hourInitial.substring(0, 5);
            const endTime = schedule.hourFinal.substring(0, 5);


            this.businessHoursMap.forEach((hours,index) => {
              hours.daysOfWeek=[index]
              hours.startTime= "00:00"
              hours.endTime= "00:00"
            })

            if (!this.businessHoursMap[dayNumber]) {
              this.businessHoursMap[dayNumber] = { daysOfWeek: [dayNumber], startTime, endTime };
            }
            else if(this.businessHoursMap[dayNumber]){
              this.businessHoursMap[dayNumber] = { daysOfWeek: [dayNumber], startTime, endTime };
            }
        });

          //Filtering of unavailable time slots
          const noAvailableSlots = value.blocksWithoutPreferenceDTO
          // const noAvailableSlots = value.scheduledDatesDTOs.filter(
          //   (event) => event.isAvailable === false
          // );
          // //If there are unavailable slots, it converts the start and end dates to Date objects and adds them to 'this.notAvailableSlots.'
          // if ( noAvailableSlots.length > 0 ) {
          //   noAvailableSlots.forEach((element) => {
          //   this.BloquesFiltered.push({start:new Date(element.start), end:new Date(element.end),  display: 'background'})
          //   // this.notAvailableSlots.push(new Date(element.start),new Date(element.end),new Date(element.end))
          //   })
          // }

          //Processing of blocked services by workshop
          if (value.blockedByWorkshopDTO && value.blockedByWorkshopDTO.length > 0) {
            this.workshopBlockedServices= value.blockedByWorkshopDTO
            //Filter blocked services by workshop according to service type
            const selectedServiceBlockedServices= value.blockedByWorkshopDTO.filter((blockedServices) => blockedServices.serviceWorkshopId === this.typeOfServiceId )
            //The function converts the start and end dates and times of the selected blocked services to `Date` objects and adds them to a list of unavailable slots.
            selectedServiceBlockedServices.forEach((element) => {
              element.start = this.addObjectDateTimePropery(element.initialDate,element.hourInitial)
              element.end = this.addObjectDateTimePropery(element.finalDate, element.hourFinal)
              this.BloquesFiltered.push({start:new Date(element.start), end:new Date(element.end),  display: 'background'})
            })
          }

           //Processing of blocked services by advisor
           if (value.blocksWithoutPreferenceDTO&& value.blocksWithoutPreferenceDTO.length > 0) {
            const selectedServiceBlockedServicesAdvisor= value.blocksWithoutPreferenceDTO
            //The function converts the start and end dates and times of the selected blocked services to `Date` objects and adds them to a list of unavailable slots.
            selectedServiceBlockedServicesAdvisor.forEach((element) => {
              this.BloquesFiltered.push({start:new Date(element.dateInitial), end:new Date(element.dateFinal),  display: 'background'})
            })
          }

          let fecha = new Date();
          fecha.setHours(0, 0, 0, 0);
          let fechafin =new Date()
          fechafin.setHours(fechafin.getHours()+1, 0, 0, 0);
          this.BloquesFiltered.push({start:fecha, end:fechafin,  display: 'background'})
          fecha = new Date(new Date().getFullYear(), 0, 1);
          fechafin =new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()-1)
          fechafin.setHours(23, 0, 0, 0)
          this.BloquesFiltered.push({start:fecha, end:fechafin,  display: 'background'})
          this.BloquesFiltered.forEach(blockedService=>{
              if(blockedService.start.getFullYear() === blockedService.end.getFullYear()  && blockedService.start.getFullYear() >= new Date().getFullYear() ){
                if(this.getDayOfYear(blockedService.start) !==this.getDayOfYear(blockedService.end) ){

                   let HourInitial = String(blockedService.start).split(' ')[4]
                   let HourIFinal = String(blockedService.end).split(' ')[4]
                    for(let i = this.getDayOfYear(blockedService.start); i<= this.getDayOfYear(blockedService.end) ; i++){
                      if( i >= this.getDayOfYear(new Date()) && blockedService.start.getFullYear() === new Date().getFullYear()) {

                        this.DisableDates.push({start:new Date(this.getDateFromDayOfYear(blockedService.start.getFullYear(),i,Number(HourInitial.split(':')[0]),Number(HourInitial.split(':')[1]),0)), end:new Date(this.getDateFromDayOfYear(blockedService.end.getFullYear(), i,Number(HourIFinal.split(':')[0]),Number(HourIFinal.split(':')[1]),0)),  display: 'background'})}
                        if( blockedService.start.getFullYear() >= new Date().getFullYear()) {

                          this.DisableDates.push({start:new Date(this.getDateFromDayOfYear(blockedService.start.getFullYear(),i,Number(HourInitial.split(':')[0]),Number(HourInitial.split(':')[1]),0)), end:new Date(this.getDateFromDayOfYear(blockedService.end.getFullYear(), i,Number(HourIFinal.split(':')[0]),Number(HourIFinal.split(':')[1]),0)),  display: 'background'})}
                        }
                }
                else{
                  this.DisableDates.push({start:blockedService.start, end:blockedService.end,  display: 'background'})
                }
              }
          })


          this.schedulerEvents = this.schedulerEvents.concat(this.DisableDates);
          return noAvailableSlots;
        }),
        tap({
          complete: () => {

            this.isSearchingSchedules = false;
            this.displayDefaultLegends = false;
            this.isSearchedByPlate = false;
            setTimeout(() => {
              this.displayDate = new Date()
             }, 250); // just refrest quicly to show blocks

          },
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
  }

  //WORKSHOP SUPER ADMIN (role id 2)
  onWorkshopSuperAdminFilterSearchClick():void {
    this.plateNumberSearch=''
    this.isSearchedByPlate= false
    this.notAvailableSlots=[]
    this.attentionSchedule = [];
    this.schedulerEvents = [];
    this.isSearchingSchedules = true;
    //if advisor is selected get scheduler of the advisor
    if (this.advisor > 0) {
      this.getServiceAdvisorData(this.advisor);
      return;
    }
  }

  getServiceAdvisorData(advisorId: number) {
    this.BloquesFiltered =[]
    this.schedulerEvents =[]
    this.DisableDates =[]
    this.isAdvisorQueryCalled = true;
    if (this.userProfile.advisorId) {
      this.APIServiceAdvisorBlockedSchedule.GetBlocksByAdvisorId(advisorId,this.userProfile.workshopId).subscribe((response)=>{

       if(response.message  !== 'No data to show.'){
        response.forEach((block)=>{
        this.BloquesFiltered.push({start:new Date(block.start), end:new Date(block.end),  display: 'background'})
      })}

      })
    }
    this.schedulerData$ = this.customScheduleService
      .getSchedulerByAdvisor(advisorId)
      .pipe(
        map((schedulesByAdvisor: any) => {
          this.prevMonth()

          if (schedulesByAdvisor.message || !schedulesByAdvisor.serviceAdvisorScheduleDTO || schedulesByAdvisor.serviceAdvisorScheduleDTO.length === 0) {
            //No hay disponibilidad horaria asignada, no se puede agendar
            this.businessHoursMap[0] =
            {
                daysOfWeek: [1, 2, 3, 4],
                startTime: "00:00",
                endTime: "00:00"
            }
            const translateText=this.translate.instant('NotTimeAvailabilityError')
            this.helperService.showAlert =true
            this.helperService.typeAlert ="error"
            this.helperService.messageAlert =translateText


            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)
            this.displayDefaultLegends = true;
          } else {

            if (this.typeOfServiceId > 0) { //is a profile with filters

              this.isSearchedByPlate = false;
              // Add workshop blocked services to custom schedule
              if (schedulesByAdvisor.blockedservicesByServiceAdvisor?.length) {

                const workshopBlock = schedulesByAdvisor.blockedservicesByServiceAdvisor.filter(
                  (x) => x.serviceWorkshopId === this.selectedTypeOfService!.serviceId && x.brandId === this.selectedBrand!.brandId
                );
                workshopBlock.forEach((blockedService) => {
                  blockedService.start = this.addObjectDateTimePropery(
                    blockedService.initialDate,
                    blockedService.hourInitial
                  );
                  blockedService.end = this.addObjectDateTimePropery(
                    blockedService.finalDate,
                    blockedService.hourFinal
                  );

                  this.BloquesFiltered.push({start:blockedService.start, end:blockedService.end,  display: 'background'})

                  // this.notAvailableSlots.push(blockedService.start, blockedService.end, recurrenceRule)

                });

              }

              // Add serviceAdvisor blocked services to custom schedule
              if (schedulesByAdvisor.serviceAdvisorBlockedServices?.length) {

                const filteredBlockedServices = schedulesByAdvisor.serviceAdvisorBlockedServices.filter(
                  (x) => x.serviceWorkshopId === this.selectedTypeOfService!.serviceId && x.brandId === this.selectedBrand!.brandId
                );

                filteredBlockedServices.forEach((blockedService) => {

                  blockedService.start = this.addObjectDateTimePropery(
                    blockedService.initialDateBlockedServices,
                    blockedService.hourInitialBlockedServices
                  );
                  blockedService.end = this.addObjectDateTimePropery(
                    blockedService.finalDateBlockedServices,
                    blockedService.hourFinaBlockedServices
                  );
                  blockedService.brandName = blockedService.brandName;
                  this.BloquesFiltered.push({start:blockedService.start, end:blockedService.end,  display: 'background'})
                });


              }
            }
            // Crear una nueva fecha para la fecha actual
            let fecha = new Date();
            fecha.setHours(0, 0, 0, 0);
            let fechafin =new Date()
            fechafin.setHours(fechafin.getHours()+1, 0, 0, 0);
            this.BloquesFiltered.push({start:fecha, end:fechafin,  display: 'background'})
            fecha = new Date(new Date().getFullYear(), 0, 1);
            fechafin =new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()-1)
            fechafin.setHours(23, 0, 0, 0)
            this.BloquesFiltered.push({start:fecha, end:fechafin,  display: 'background'})
            this.BloquesFiltered.forEach(blockedService=>{
                if(blockedService.start.getFullYear() === blockedService.end.getFullYear()  && blockedService.start.getFullYear() >= new Date().getFullYear() ){
                  if(this.getDayOfYear(blockedService.start) !==this.getDayOfYear(blockedService.end) ){

                     let HourInitial = String(blockedService.start).split(' ')[4]
                     let HourIFinal = String(blockedService.end).split(' ')[4]
                      for(let i = this.getDayOfYear(blockedService.start); i<= this.getDayOfYear(blockedService.end) ; i++){
                        if( i >= this.getDayOfYear(new Date()) && blockedService.start.getFullYear() === new Date().getFullYear()) {

                          this.DisableDates.push({start:new Date(this.getDateFromDayOfYear(blockedService.start.getFullYear(),i,Number(HourInitial.split(':')[0]),Number(HourInitial.split(':')[1]),0)), end:new Date(this.getDateFromDayOfYear(blockedService.end.getFullYear(), i,Number(HourIFinal.split(':')[0]),Number(HourIFinal.split(':')[1]),0)),  display: 'background'})}
                          if( blockedService.start.getFullYear() >= new Date().getFullYear()) {

                            this.DisableDates.push({start:new Date(this.getDateFromDayOfYear(blockedService.start.getFullYear(),i,Number(HourInitial.split(':')[0]),Number(HourInitial.split(':')[1]),0)), end:new Date(this.getDateFromDayOfYear(blockedService.end.getFullYear(), i,Number(HourIFinal.split(':')[0]),Number(HourIFinal.split(':')[1]),0)),  display: 'background'})}
                          }
                  }
                  else{
                    this.DisableDates.push({start:blockedService.start, end:blockedService.end,  display: 'background'})
                  }
                }
            })
            schedulesByAdvisor.customAdvisorSchedule.forEach((element) => {
              element.start = new Date(element.start);
              element.end = new Date(element.end);
            });



              this.schedulerEvents = schedulesByAdvisor.customAdvisorSchedule //.filter((element) => new Date(element.start) >= new Date(new Date().setHours(0, 0, 0, 0)))
            this.schedulerEvents.map((event) => {event.title =  event.brandName
              event.EventStart = event.start
              event.EventEnd = event.end
            })

          this.schedulerEvents = this.schedulerEvents.concat(this.DisableDates);

          this.workshopBlockedServices= schedulesByAdvisor.blockedservicesByServiceAdvisor
          this.businessHoursMap.forEach((hours,index) => {
            hours.daysOfWeek=[index]
            hours.startTime= "00:00"
            hours.endTime= "00:00"
          })

          schedulesByAdvisor.serviceAdvisorScheduleDTO.forEach(schedule => {
              const dayNumber = parseInt(schedule.dayNumber);
              const startTime = schedule.hourInitialAdvisorSchedule.substring(0, 5);
              const endTime = schedule.hourFinaAdvisorSchedule.substring(0, 5);


              if (!this.businessHoursMap[dayNumber]) {
                this.businessHoursMap[dayNumber] = { daysOfWeek: [dayNumber], startTime, endTime };
              }
              else if(this.businessHoursMap[dayNumber]){
                this.businessHoursMap[dayNumber] = { daysOfWeek: [dayNumber], startTime, endTime };
              }

          });

            this.attentionSchedule = schedulesByAdvisor.serviceAdvisorScheduleDTO;
            this.servicesBlocksAdvisor =schedulesByAdvisor.serviceAdvisorBlockedServices;

            return;
          }
        }),
        tap({
          complete: () => {
            this.isSearchingSchedules = false;
            this.displayDefaultLegends = false;
           setTimeout(() => {
            this.displayDate = new Date()
           }, 250);
          },
        }) , catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
  }

 getDayOfYear(date: Date): number {
    const start = new Date(date.getFullYear(), 0, 0);
    const diff = date.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
}

getDateFromDayOfYear(year: number, dayOfYear: number, hour: number, minute: number, second: number): string {
  const start = new Date(year, 0, 0);
  const date = new Date(start.getTime() + dayOfYear * 24 * 60 * 60 * 1000);
  date.setHours(hour, minute, second, 0);

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const month = monthsOfYear[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  const yearStr = date.getFullYear();
  const hourStr = String(date.getHours()).padStart(2, '0');
  const minuteStr = String(date.getMinutes()).padStart(2, '0');
  const secondStr = String(date.getSeconds()).padStart(2, '0');

  const timezoneOffset = date.getTimezoneOffset();
  const timezoneHours = Math.abs(Math.floor(timezoneOffset / 60));
  const timezoneMinutes = Math.abs(timezoneOffset % 60);
  const timezoneSign = timezoneOffset > 0 ? '-' : '+';
  const timezone = `GMT${timezoneSign}${String(timezoneHours).padStart(2, '0')}${String(timezoneMinutes).padStart(2, '0')}`;

  return `${dayOfWeek} ${month} ${day} ${yearStr} ${hourStr}:${minuteStr}:${secondStr} ${timezone} (hora estándar de Colombia)`;
}
  evaluateUser():void {
    // This function evaluates the user profile role ID to determine which data to retrieve.
    this.searchedFilterElement = 'Advisors';

    switch (this.roleId) {
      case 1:
        this.getServiceAdvisorData(this.userProfile.advisorId);
        break;
      case 6: // same function for workshopAdmin and WorkshopAssistant
      case 2:
        this.userProfileId = this.userProfile.workshopId;
        this.advisors$ = this.customScheduleService
          .getScheduleDropDownLists(
            this.roleId,
            this.userProfileId
          )
          .pipe(
            tap({
              complete: () => (this.areFiltersLoading = false),
            }), catchError((error: any) => {
              // Handle validation error here
              if(error.status === 401){
               this.helperService.logoutToken()
             }
            console.error('Validation Error:', error);
            // Rethrow the error to propagate it downstream
            return throwError(error);
            })
          );

        break;
      case 3: //contact center
        this.searchedFilterElement = 'Brands';
        this.brands$ = this.brandsService.getBrandsByCountryId(this.helperService.user.countryId).pipe(
          tap({
            complete: () => (this.areFiltersLoading = false),
          }), catchError((error: any) => {
            // Handle validation error here
            if(error.status === 401){
             this.helperService.logoutToken()
           }
          console.error('Validation Error:', error);
          // Rethrow the error to propagate it downstream
          return throwError(error);
          })
        );
        break;
      case 4: //temporary includes retail
      this.searchedFilterElement = 'Brands';
      this.brands$ = this.brandsService.getBrandsRetail(this.userProfile.retailId).pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
        break;

      default:
        // Handle unknown role ID
        break;
    }
  }

  timeToSeconds(time: string): number {
    // recieve an string of hours, minutes and seconds
    const [hours, minutes, seconds] = time.split(':');
    return (
      parseInt(hours, 10) * 60 * 60 +
      parseInt(minutes, 10) * 60 +
      parseInt(seconds, 10)
    );
    // returns time in seconds
  }
  displayDate: Date = new Date(); // Date showed by scheduler (today by default)

  onPlateNumberSearchClick(): void {
    this.attentionSchedule=[]
    this.notAvailableSlots = []
    // this.businessHoursMap=[]
    this.brandId=0
    this.cityId=0
    this.typeOfServiceId=0
    this.workshop=0
    this.advisor=0
    // function to search by plate
    this.brandId=0

    this.displayDefaultLegends = true;
    this.isSearchingSchedules = true;
    this.schedulerData$ = this.customScheduleService
      .getByPlateIdentification("0",this.plateNumberSearch,"1","20")
      .pipe(
        map((v) => {

          if (v !== null) {

            v.forEach((element) => {
              // transform ISOString to Date object (scheduler must recieve a date object)
              element.start = new Date(element.start);
              element.end = new Date(element.end);

            });
            this.schedulerEvents = v; // set events of the scheduler


           if(this.businessHoursMap.length>0){   this.businessHoursMap.forEach((day,index) => {
            day.daysOfWeek= [index],
            day.startTime= "00:00",
            day.endTime= "00:00"

          })}
          else {
            this.businessHoursMap[0] =
              {
                  daysOfWeek: [1, 2, 3, 4],
                  startTime: "00:00",
                  endTime: "00:00"
              }
          }


            this.schedulerEvents.map((event) => {event.title =  event.brandName
              event.EventStart = event.start
              event.EventEnd = event.end
            })


            this.calendarOptions.initialDate=this.schedulerEvents[0].start

            const translateText= this.translate.instant('FindPlateMsg', {
              schedulerEventsLength: this.schedulerEvents.length,
              plateNumberSearch: this.plateNumberSearch
            });
           this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateText

            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)


            // change the view to the last schedule recieved
            this.displayDate=   this.schedulerEvents[this.schedulerEvents.length-1].start // set showed date after search //maybe required  later
          }


          return v;
        }),
        tap({
          next: (value) => {
              
            if (value === null) {
              // this happends when any kind of error occurs
              const translateText=this.translate.instant('NotfoundPlateMsg', {
                plateNumberSearch: this.plateNumberSearch.toLocaleUpperCase()
              });
              this.helperService.showAlert =true
              this.helperService.typeAlert ="error"
              this.helperService.messageAlert =translateText

              setTimeout(() => {
                this.helperService.showAlert =false

                }, 7000)
               this.isSearchingSchedules = false;
            }
          },
          error: (failed) => {

            console.error('error consulting data', failed);

            this.isSearchingSchedules = false;
          },
          complete: () => {
            this.isSearchingSchedules = false;
            this.displayDefaultLegends = false;

          },
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    this.isSearchedByPlate = true;
  }
  onBrandIdWorkshopChange(brandId: number) {
    const workshopId= this.userProfile.workshopId
    this.APIWorkshopService.getCountryBrandRetailIdByBrandAndWorkshopId(brandId,workshopId).pipe(
      tap({next:(element:any)=>{
        this.slotDuration= element[0].dateLength
        if(this.slotDuration>60){
          let Duration = this.slotDuration -60
          this.calendarOptions.slotDuration = `01:${Duration}:00 `
        }
        else{this.calendarOptions.slotDuration = `00:${this.slotDuration}:00 `}

      }}


    ), catchError((error: any) => {
      // Handle validation error here
      if(error.status === 401){
       this.helperService.logoutToken()
     }
    console.error('Validation Error:', error);
    // Rethrow the error to propagate it downstream
    return throwError(error);
    })).subscribe()
      if(this.brandId === 7){
        this.slotDuration = 45
        this.calendarOptions.slotDuration = `00:${this.slotDuration}:00 `
      }
  }
  onBrandIdChange(brandId: number) {
    // This function is used to update the next dropdown lists and reset other values

    this.searchedFilterElement = 'Cities';
    this.areFiltersLoading = true;
    //evaluate if another things are selected
    if (this.helperService.user.role.roleId===3) {
      this.cities$ = this.customScheduleService

      .getScheduleDropDownLists(
        this.roleId,
        this.userCountryId,
        brandId
      )
      .pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    } else if (this.helperService.user.role.roleId === 4) {
      this.cities$ = this.customScheduleService

      .getScheduleDropDownLists(
        this.roleId,
        this.helperService.user.retailId,
        brandId
      )
      .pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }

    this.cityId = 0;
    this.typeOfServiceId = 0;
    this.workshop = 0;
    this.advisor = 0;
    this.displayDefaultLegends=true
  }

  onCityIdChange(countryId: number, brandId: number, cityId: number): void {
    //  used to update the filters when a cityId is changed
    this.searchedFilterElement = 'TypesOfService';
    this.areFiltersLoading = true;
    this.displayDefaultLegends = true
    if (this.helperService.user.role.roleId===3) { //contact center
      this.typesOfservice$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        countryId,
        brandId,
        cityId
      )
      .pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }
    if (this.helperService.user.role.roleId === 4) { //retail Group
      this.typesOfservice$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        this.helperService.user.retailId,
        brandId,
        cityId
      )
      .pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }

    this.typeOfServiceId = 0;
    this.workshop = 0;
    this.advisor = 0;
  }
  onTypeOfServiceIdChange(
    countryId: number,
    brandId: number,
    cityId: number,
    typeOfServiceId: number
  ): void {
    this.areFiltersLoading = true;
    this.displayDefaultLegends=true
    this.searchedFilterElement = 'Workshops';
    this.workshop = 0;
    this.advisor = 0;
    if (this.helperService.user.role.roleId===3) { // contact center
      this.workshops$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        countryId,
        brandId,
        cityId,
        typeOfServiceId
      )
      .pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }
    if (this.helperService.user.role.roleId===4) { // retail group
      this.workshops$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        this.helperService.user.retailId,
        brandId,
        cityId,
        typeOfServiceId
      )
      .pipe(
        tap({
          complete: () => (this.areFiltersLoading = false),
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }

  }

  onChangeWorkshop(
    countryId: number,
    brandId: number,
    cityId: number,
    typeOfServiceId: number,
    workshopId: number
  ) :void {
    this.searchedFilterElement = 'Advisors';
    this.displayDefaultLegends=true
    this.areFiltersLoading = true;
    this.advisor = 0;

    if (this.helperService.user.role.roleId === 3) { //contact center

      this.advisors$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        countryId,
        brandId,
        cityId,
        typeOfServiceId,
        workshopId
      )
      .pipe(
        tap({

          complete: () => {
            (this.areFiltersLoading = false)
            this.slotDuration = this.selectedWorkshop?.dateLength
            if(this.slotDuration>60){
              let Duration = this.slotDuration -60
              this.calendarOptions.slotDuration = `01:${Duration}:00 `
            }
            else{this.calendarOptions.slotDuration = `00:${this.slotDuration}:00 `}
          },

        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }
    if (this.helperService.user.role.roleId === 4) { // retail group
      this.advisors$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        this.helperService.user.retailId,
        brandId,
        cityId,
        typeOfServiceId,
        workshopId
      )
      .pipe(
        tap({
          complete: () => {
            (this.areFiltersLoading = false)
            this.slotDuration = this.selectedWorkshop?.dateLength
            if(this.slotDuration>60){
              let Duration = this.slotDuration -60
              this.calendarOptions.slotDuration = `01:${Duration}:00 `
            }
            else{this.calendarOptions.slotDuration = `00:${this.slotDuration}:00 `}

          },

        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
    }



  }
  onAdvisorChange(advisorId:number) :void{
    this.searchedFilterElement = 'TypesOfService';
    this.areFiltersLoading = true;
    this.displayDefaultLegends=true
    this.typesOfservice$ = this.customScheduleService
      .getScheduleDropDownLists(
        this.roleId,
        this.userProfileId,
        advisorId
      )
      .pipe(
        tap({
          complete: () => {
            this.areFiltersLoading = false;
            this.isTypeOfServiceAdminDisabled = false;
          },
        }), catchError((error: any) => {
          // Handle validation error here
          if(error.status === 401){
           this.helperService.logoutToken()
         }
        console.error('Validation Error:', error);
        // Rethrow the error to propagate it downstream
        return throwError(error);
        })
      );
  }
  getAdvisorServiceBrands(typeOfServiceId: number) {

    this.brands$= this.customScheduleService.getScheduleDropDownLists(this.roleId,this.helperService.user.workshopId,this.advisor,typeOfServiceId).pipe(
      catchError((error: any) => {
        // Handle validation error here
        if(error.status === 401){
         this.helperService.logoutToken()
       }
      console.error('Validation Error:', error);
      // Rethrow the error to propagate it downstream
      return throwError(error);
      })

  );
  }


  prevMonth() {
    const currentDate = new Date();

    // get the current month and year
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    // calculate the new month and year
    const newMonth = currentMonth - 1;
    const newYear = currentYear;

    // create a new Date object for the new date
    const newDate = new Date(newYear, newMonth, currentDate.getDate());
    this.displayDate= newDate
  }


  onClearFilterClick() {
    // clean all values
    this.notAvailableSlots=[]
    this.schedulerEvents = [];
    this.attentionSchedule = [];
    this.brandId = 0;
    this.advisor = 0;
    this.cityId = 0;
    this.typeOfServiceId = 0;
    this.workshop = 0;
    this.isSearchedByPlate = false;
    this.displayDefaultLegends = true;
    this.selectedAdvisor = undefined;
    this.selectedBrand = undefined
    this.selectedTypeOfService = undefined;
    this.selectedWorkshop = undefined;
    this.selectedCity = undefined
    this.displayDefaultLegends = true
    this.isSearchingSchedules=false
  }
  onPlateNumberClear() {
    // clears value of searched string

    this.plateNumberSearch = '';
    this.isSearchedByPlate = false;
    if (this.userProfile.advisorId) {
      // if advisorId exists then get its data
      this.getServiceAdvisorData(this.userProfile.advisorId);
    } else {
      this.schedulerEvents = [];
      this.displayDefaultLegends = true;
    }
    //add function to reset search depending on user (SA must reset it's dates)
    //CC must clear schedule dates and filters
  }
  //function to reload Scheduler

  isCityFieldDisabled(): boolean {
    // This function checks if the city field is disabled. It returns a boolean value, true if the brandId is equal to 0, and false otherwise.


    return this.brandId === 0;
  }
  isTypeOfServiceDisabled(): boolean {
    // This function checks if the typeOfService field is disabled. It returns a boolean value, true if the typeOfService is equal to 0, and false otherwise.


    return this.cityId === 0;
  }
  isTypeOfServiceAdminDisabled: boolean = true;
  isSearchDisabled(): boolean {
    // function to enable search button conditionally of CC
    let nopreferenceContacts: boolean = true;
    if(this.userProfile.role.roleId === 4){
      nopreferenceContacts = false;
      if(this.advisor > 0){
        nopreferenceContacts = true;
      }
    }
    return !(
      this.brandId &&
      this.cityId &&
      this.typeOfServiceId &&
      this.workshop && nopreferenceContacts
    );
  }
  isSearchWSAsearchDisabled(): boolean {
    // This function returns a boolean value to enable the search button conditionally.
    // It will return true if any of the values of brandId, cityId, typeOfServiceId, or workshop are falsey. Otherwise it will return false.
    const { advisor, typeOfServiceId, brandId } = this;
    return advisor === 0 || typeOfServiceId <= 0 || brandId <= 0;
  }
  isWorkshopDisabled(): boolean {
    return this.typeOfServiceId === 0;
  }

  isAdvisorDisabled(): boolean {
    return this.workshop === 0;
  }
  isClearDisabled(): boolean {
    // function to enable clear button conditionally
    return (
      this.brandId === 0 &&
      this.cityId === 0 &&
      this.typeOfServiceId === 0 &&
      this.workshop === 0 &&
      this.advisor === 0
    );
  }
  hoveredData: string = '';


  cancelAppointment() {
    // Opens the dialog to cancel scheduled appointment and listens for recieved object
    let appointment = JSON.parse(this.hoveredData);

    this.dialog.open(CancelAppointmentDialog, {
      width: '600px',
      panelClass: 'icon-outside',
      data: appointment,
    });

  }

  rescheduleAppointment() {
    let appointment = JSON.parse(this.hoveredData);
    // Service Advisor
    if (this.roleId === 1) {
      appointment.attentionSchedule = this.attentionSchedule;
      appointment.schedules = this.schedulerEvents;
      appointment.blocks = this.servicesBlocksAdvisor;
    }
    //Workshop
    if (this.roleId === 2) {
      appointment.attentionSchedule = this.attentionSchedule;
      appointment.schedules = this.schedulerEvents;
      appointment.blocks = this.servicesBlocksAdvisor;
    }

    //CONTACT CENTER
    if (this.roleId===3) {
      appointment.advisorAttentionSchedule = this.attentionSchedule
      appointment.schedules= this.schedulerEvents
      appointment.blocks=this.servicesBlocksAdvisor
    }



    this.dialog.open(RescheduleAppointmentDialog, {
      width: '903px',
      panelClass: 'icon-outside',
      data: appointment,
    });
  }

  serchBlockSlotTimeAdvisor(slot: any):boolean{

    let blockHours:any[] = []
    let hourInitialBlockedServices = 0    
    let hourFinalBlockedServices = 0      
    let timeDate = 0    

    
    let HourFinal = moment.duration(this.attentionSchedule.filter(a=> a.dayNumber === String(slot.start.getDay()))[0].hourFinaAdvisorSchedule).asHours()
    
    this.schedulerEvents.forEach(element => {
        if ( (slot.start!.getDate() >= new Date(element.start ).getDate() && slot.start!.getDate()<=new Date(element.end).getDate() &&  slot.start!.getMonth() === new Date(element.start ).getMonth()) &&  slot.start!.getFullYear() ===new Date(element.start ).getFullYear())
          {
            let stringEnd = element.end.toString()
            let stringStart = element.start.toString()
            blockHours.push({initialHourBlock:stringStart.split(' ')[4],finalHourBlock :stringEnd.split(' ')[4]})
          }
      });

      let endHoursMinutes = slot.start.getMinutes() + this.slotDuration
      let endHour = slot.start.getHours()

      if(endHoursMinutes >= 60){
        endHour=  endHour + 1
        endHoursMinutes = endHoursMinutes - 60
      }

      for (let i = moment.duration(''+slot.start.getHours()+":"+slot.start.getMinutes()+':00').asHours(); i < moment.duration(''+endHour+":"+endHoursMinutes+':00').asHours(); i += moment.duration('00:05:00').asHours())
      {

      let blockSelect = blockHours.filter(blockHours =>blockHours.initialHourBlock === ('0' + Math.floor(i*60/60)).slice(-2) + ':' + ('0' + Math.round(i*60%60)).slice(-2)+':00')

      if(blockSelect.length > 0)
        {
          hourInitialBlockedServices = moment.duration(blockSelect[0].initialHourBlock).asHours()
          hourFinalBlockedServices = moment.duration(blockSelect[0].finalHourBlock).asHours()
        }

        if(i>= hourFinalBlockedServices &&  HourFinal>= i) timeDate = timeDate + 5
      }


      if(timeDate >= this.slotDuration) return true
      else return false

  // else return false

  }

  openDialog(slot: any): void {
    let isCrossedDate

    let originalTime = new Date(slot.date);
    let newTime = new Date(originalTime.getTime() + this.slotDuration * 60000);
    slot.start= slot.date,
    slot.end= newTime

    if(!slot.jsEvent.target.classList.contains('fc-bg-event') && !slot.jsEvent.target.classList.contains('fc-non-business')) {
      isCrossedDate =   this.serchBlockSlotTimeAdvisor(slot)  }
    if(!isCrossedDate){

    const dateString = this.titleCasePipe.transform(
      `${new Date(slot.date ).
        toLocaleDateString(
          this.helperService.user.language,
          { weekday: 'long',month: 'long', day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true }
          )
        }
          `);
          const translateText= this.translate.instant('AppointmentOverlapError', {
           date: dateString
          });
          const capitalizedText = this.capitalizePipe.transform(translateText)
          this.helperService.showAlert =true
          this.helperService.typeAlert ="warning"
          this.helperService.messageAlert =capitalizedText

          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)
   }



    if(!slot.jsEvent.target.classList.contains('fc-bg-event') && !slot.jsEvent.target.classList.contains('fc-non-business') &&  isCrossedDate){

 

  //       /*    This code is checking to see if a certain event meets any of three criteria: 
  // 1. The event has been searched by plate 
  // 2. The event start date is before or equal to the current date 

  // 3. There is an event on the slot
  // */
      if (this.isSearchedByPlate ||
        slot.date
        <= new Date() 

         )

         {
          if (!this.isSearchedByPlate) {
            const dateString = this.titleCasePipe.transform(
              `${new Date(slot.date ).
                toLocaleDateString(
                  this.helperService.user.language,
                  { weekday: 'long',month: 'long', day: 'numeric',hour: 'numeric', minute: 'numeric', hour12: true }
                  )
                }
                  `);
                  const translateText= this.translate.instant('AppointmentOverlapError', {
                   date: dateString
                  });
                  const capitalizedText = this.capitalizePipe.transform(translateText)
                  this.helperService.showAlert =true
                  this.helperService.typeAlert ="warning"
                  this.helperService.messageAlert =capitalizedText

                  setTimeout(() => {
                    this.helperService.showAlert =false

                    }, 7000)
          }


        return;
      }

      const appointmentSchedule: any = {
        start: slot.date,
        end: newTime,
      };

      if (this.isAdvisorQueryCalled) {
        //checks if advisor query has been called it means service advisor or an advisor is selected on a dropdown
        const selectedDay = new Date(slot.date).getDay();

        const hasAdvisorAttentionHours = this.attentionSchedule.some(
          (x) => Number(x.dayNumber) === selectedDay
        );

        if (hasAdvisorAttentionHours) {
          // happens when the advisor availability is already set (by workshop or admin)
          appointmentSchedule.blockedServices = this.servicesBlocksAdvisor;
          appointmentSchedule.advisorAttentionHoursDays = this.attentionSchedule;
          if (this.workshopBlockedServices.length > 0) {
           // checks if there is a blocked service
          appointmentSchedule.workshopBlockedServices= this.workshopBlockedServices
         }
          if (this.advisor) {
               // checks if the advisor has been selected from a dropdown then set properties
            appointmentSchedule.typeOfService = this.selectedTypeOfService;
            appointmentSchedule.advisor = this.selectedAdvisor;
            appointmentSchedule.brand = this.selectedBrand;
            appointmentSchedule.workshop = this.selectedWorkshop;
            appointmentSchedule.city = this.selectedCity;

            // date >= startDate && date <= endDate; // date is the date to evaluate

          }
       //evaluate if there is a date between the slot to prevent the modal to open
              //event.start is the start of the slot
              //e.start is the start of the event (schedules or blocks)

            this.dialog.open(SearchPlateDialog, {
              width: "460px",
              panelClass: "icon-outside",
              data: appointmentSchedule,
            });

        }
      } else {
        appointmentSchedule.brand = this.selectedBrand;
        appointmentSchedule.city = this.selectedCity;
        appointmentSchedule.typeOfService = this.selectedTypeOfService;
        appointmentSchedule.workshop = this.selectedWorkshop;
        if (this.workshopBlockedServices.length > 0) {
          // checks if there is a service blocked by the workshop
          appointmentSchedule.workshopBlockedServices= this.workshopBlockedServices
         }
        this.dialog.open(SearchPlateDialog, {
          width: "460px",
          panelClass: "icon-outside",
          data: appointmentSchedule,
        });
      }
  }
  }

  onScheduleStateChange() {
    //evaluates if an schedule is added, edited or deleted and reDo the action of the profile
      //SA -> load its schedules
      //other profiles -> redo scheduleSearch
    //NOTE: That actions must be call the service and set to it to true on its own components to make trigger the update

    this.scheduleStateService.isStateChanged.subscribe((isSaved) => {

      if (isSaved) {
        this.schedulerEvents=[]
        const userRol = this.helperService.user.role.roleId
        if (this.isSearchedByPlate) {
          if(this.helperService.cancelacion_citas) {
            this.helperService.cancelacion_citas = false
          }
          else{this.onPlateNumberSearchClick()}
        } else {
          switch(  userRol) {
            case 1:

              this.getServiceAdvisorData(this.helperService.user.advisorId)
              break;
            case 2:
              this.onWorkshopSuperAdminFilterSearchClick()

              break;
              case 3:
              case 4:
              this.onCCRGFilterSearchClick()
              break;
              case 6:
              this.onWorkshopSuperAdminFilterSearchClick()
              break;
            default:
              break;
          }
        }

      this.scheduleStateService.changeScheduleState(false)

    }})
  }
}
